import React from 'react';
import {
	PublishOffer,
} from './GeneralNotif';
import DefaultNotification from '../NotificationsCards/Default';
import CertiVerificationNotification from '../NotificationsCards/fileVerifications/CertiVerificationNotification';
import IdVerificationNotification from '../NotificationsCards/fileVerifications/IdVerificationNotification';
import PictureVerificationNotification from '../NotificationsCards/fileVerifications/PictureVerificationNotification';
import ExpiredOfferNotification from '../NotificationsCards/offers/ExpiredOfferNotification';
import NewOvertimeAcceptedNotification from '../NotificationsCards/overtimes/NewOvertimeAcceptedNotification';
import NewOvertimeDeclinedNotification from '../NotificationsCards/overtimes/NewOvertimeDeclinedNotification';
import NewOvertimeProposalNotification from '../NotificationsCards/overtimes/NewOvertimeProposalNotification';
import NewProductAcceptedNotification from '../NotificationsCards/products/NewProductAcceptedNotification';
import NewProductDeclinedNotification from '../NotificationsCards/products/NewProductDeclinedNotification';
import NewProductProposalNotification from '../NotificationsCards/products/NewProductProposalNotification';
import AdminMessageNotification from '../NotificationsCards/AdminMessageNotification';
import ExpiredRequestNotification from '../NotificationsCards/Request/ExpiredRequestNotification';
import NewTransactionNotification from '../NotificationsCards/transactions/NewTransactionNotification/NewTransactionNotification';
import TransactionWasCancelNotification from '../NotificationsCards/transactions/TransactionWasCancelNotification/TransactionWasCancelNotification';
import RequestNotification from '../NotificationsCards/transactions/RequestNotification/RequestNotification';
import DeclinedRequestNotification from '../NotificationsCards/Request/DeclinedRequestNotification/DeclinedRequestNotification';

type FactoryNotificationProps = {
	item: any;
	onSetNotificationAsView: (id: string) => void;
	navigation: any;
	deleteNotification: (notificationID: string) => void
}

export interface NotificationProps {
	clickable: boolean
	onSetNotificationAsView: (id: string) => void
}

const FactoryNotification = ({
	item,
	onSetNotificationAsView,
	navigation,
	deleteNotification
}: FactoryNotificationProps) => {
	switch (item.notifData.receivedFromType) {
		case 'New-Request':
			return (
				<RequestNotification
					onSetNotificationAsView={onSetNotificationAsView}
					item={item}
					key={item.id}
				/>
			);

		case 'Declined-Request':
			return (
				<DeclinedRequestNotification 
					onSetNotificationAsView={onSetNotificationAsView}
					item={item}
					key={item.id}
				/>
			);

		case 'Publish_Offer':
			return (
				<PublishOffer
					onSetNotificationAsView={onSetNotificationAsView}
					item={item}
					key={item.id}
					deleteNotification={deleteNotification}
				/>
			);

		case 'New-Transaction':
			return (
				<NewTransactionNotification
					onSetNotificationAsView={onSetNotificationAsView}
					item={item}
					key={item.id}
					clickable={true}
				/>
			);
		case 'admin-message':
			return (
				<AdminMessageNotification
					onSetNotificationAsView={onSetNotificationAsView}
					item={item}
					key={item.id}
					clickable={false}
				/>
			);

		case 'id-verification':
			return (
				<IdVerificationNotification
					onSetNotificationAsView={onSetNotificationAsView}
					item={item}
					key={item.id}
					clickable={false}
				/>
			);

		case 'picture-verification':
			return (
				<PictureVerificationNotification
					onSetNotificationAsView={onSetNotificationAsView}
					item={item}
					key={item.id}
					clickable={false}
				/>
			);

		case 'certi-verification':
			return (
				<CertiVerificationNotification
					onSetNotificationAsView={onSetNotificationAsView}
					item={item}
					key={item.id}
					clickable={false}
				/>
			);

		case 'new-overtime-proposal':
			return (
				<NewOvertimeProposalNotification
					onSetNotificationAsView={onSetNotificationAsView}
					item={item}
					key={item.id}
					clickable={false}
				/>
			);

		case 'new-overtime-accepted':
			return (
				<NewOvertimeAcceptedNotification
					onSetNotificationAsView={onSetNotificationAsView}
					item={item}
					key={item.id}
					clickable={false}
				/>
			);

		case 'new-overtime-declined':
			return (
				<NewOvertimeDeclinedNotification
					onSetNotificationAsView={onSetNotificationAsView}
					item={item}
					key={item.id}
					clickable={false}
				/>
			);

		case 'new-product-proposal':
			return (
				<NewProductProposalNotification
					onSetNotificationAsView={onSetNotificationAsView}
					item={item}
					key={item.id}
					clickable={true}
				/>
			);

		case 'new-product-accepted':
			return (
				<NewProductAcceptedNotification
					onSetNotificationAsView={onSetNotificationAsView}
					item={item}
					key={item.id}
					clickable={true}
				/>
			);

		case 'new-product-declined':
			return (
				<NewProductDeclinedNotification
					onSetNotificationAsView={onSetNotificationAsView}
					item={item}
					key={item.id}
					clickable={true}
				/>
			);

		case 'expired-offer':
			return (
				<ExpiredOfferNotification
					onSetNotificationAsView={onSetNotificationAsView}
					item={item}
					key={item.id}
					clickable={false}
				/>
			);

		case 'expired-request':
			return (
				<ExpiredRequestNotification
					onSetNotificationAsView={onSetNotificationAsView}
					item={item}
					key={item.id}
					clickable={false}
				/>
			);

		case 'Transaction-Cancelled':
			return (
				<TransactionWasCancelNotification
					onSetNotificationAsView={onSetNotificationAsView}
					item={item}
					key={item.id}
					clickable={false}
				/>
			);

		default:
			return <DefaultNotification {...item} />
	}
};

export default React.memo(FactoryNotification);
